import React, { useState } from 'react';
import { PrismicLink } from 'components/PrismicLink';
import { SignUpOrGoToApp, LogInLogOut, CommonNavigation } from '../CommonNavigation';
import { MainNavigationProps } from './types';

export const MainNavigation: React.FC<MainNavigationProps> = ({
    mainNavigationData,
    headerType,
    partnerUrl,
    partnerLogo,
    pageContext,
}) => {
    const [isOpened, setIsOpened] = useState(false);

    const { menu_items, login_label, signup_label, go_to_app_label, logout_label } = mainNavigationData;

    const toggleMobileMenu = () => {
        setIsOpened(!isOpened);
    };

    return (
        <CommonNavigation
            toggleMobileMenu={toggleMobileMenu}
            isMobileNavOpen={isOpened as boolean}
            headerType={headerType}
            partnerUrl={partnerUrl}
            partnerLogo={partnerLogo}
            languageCode={pageContext.lang}
            goToAppLabel={go_to_app_label}
            signupLabel={signup_label}
        >
            <ul className="MainNavigation-items" onClick={toggleMobileMenu}>
                {headerType !== 'PartnerHeader' && (
                    <>
                        {menu_items.map((item, index) => (
                            <li key={index} className="MainNavigation-item">
                                <PrismicLink
                                    label={item.label}
                                    link={item.link}
                                    className="MainNavigation-itemButton"
                                />
                            </li>
                        ))}
                        <li className="MainNavigation-item MainNavigation-item--secondary">
                            <span className="Sign-up--mobileBtn">
                                <SignUpOrGoToApp label={signup_label} goToAppLabel={go_to_app_label} />
                            </span>
                            <LogInLogOut
                                loginLabel={login_label}
                                logoutLabel={logout_label}
                                className="MainNavigation-itemButton"
                            />
                        </li>
                    </>
                )}
                <li
                    className={`MainNavigation-item MainNavigation-item--secondary Sign-up ${
                        headerType === 'PartnerHeader' ? 'SignUpPartner' : ''
                    }`}
                >
                    <span className="u-hidden-lg-down">
                        <SignUpOrGoToApp label={signup_label} goToAppLabel={go_to_app_label} />
                    </span>
                </li>
            </ul>
        </CommonNavigation>
    );
};
